import { sortArrayObject } from "./string.utils";

export const getProductPriceSlabs = (products) => {
  const priceSlabArray = [];

  for (let i = 0; i < products.length; i++) {
    for (let j = 0; j < products[i].price.price_list.length; j++) {
      const checkPriceSlab = priceSlabArray.find(
        (slab) => slab.min_qty == products[i].price.price_list[j].min_qty
      );
      //   console.log(checkPriceSlab);
      if (!checkPriceSlab)
        priceSlabArray.push({
          min_qty: products[i].price.price_list[j].min_qty,
        });
    }
  }

  return sortArrayObject(priceSlabArray, "min_qty");
};

export const filterProductsWithSlab = ({ products }) => {
  // console.log({ products });

  const productArray = [];

  for (let i = 0; i < products.length; i++) {
    const priceSlabArray = [];
    for (let j = 0; j < products[i].price.price_list.length; j++) {
      if (products[i].availability >= products[i].price.price_list[j].min_qty)
        priceSlabArray.push(products[i].price.price_list[j]);
    }

    productArray.push({
      ...products[i],
      price: { ...products[i].price, price_list: priceSlabArray },
    });
  }
  return productArray;
};

export const productQtyChange = (type, product) => {
  let copyProduct = { ...product };
  let currentQty = product?.required_qty
    ? product?.required_qty
    : product.price.min_order || 1;
  // console.log({ currentQty });
  if (type === "decrease") {
    currentQty -= parseInt(product.price.multiple);
    if (currentQty <= 0)
      copyProduct = { ...copyProduct, required_qty: product.price.multiple };
    else copyProduct = { ...copyProduct, required_qty: currentQty };
  } else {
    const qty = parseInt(currentQty) + parseInt(product.price.multiple);
    copyProduct = { ...copyProduct, required_qty: qty };
  }
  return copyProduct;
};
export const getNextSlabPrice = (product) => {
  let matchingPriceSlab = null;
  let nextSlabIndex, matchingSlabPrice;
  let nextPriceSlab = {
    nextSlabFlag: false,
    nextSlabQty: 0,
    nextSlabAmount: 0,
  };
  for (let i = 0; i < product.price.price_list.length; i++) {
    const slab = product.price.price_list[i];
    if (slab.min_qty <= product.qty) {
      matchingPriceSlab = slab;
      matchingSlabPrice = slab.price * product.qty;
      nextSlabIndex = i + 1;
    }
  }
  if (
    product.price.price_list.length > 1 &&
    product.price.price_list.length > nextSlabIndex + 1
  ) {
    let nextPrice = product.price.price_list[nextSlabIndex];
    console.log({
      NextSlab_matchingSlabPrice: matchingSlabPrice,
      NextSlab_nextPriceSlab: nextPrice.price,
    });
    if (matchingSlabPrice >= nextPrice.price * nextPrice.min_qty) {
      nextPriceSlab = {
        nextSlabFlag: true,
        nextSlabQty: nextPrice.min_qty,
        nextSlabAmount: nextPrice.price,
      };
    }
  }
  return nextPriceSlab;
};

export const findLowest = (uniquePartNumbersList, productArr) => {
  let sortProArr = [];
  let sortProduct = [];
  let onTotalPrice = 0;
  let lowestIndex = 0;
  // console.log({ uniquePartNumbersList: uniquePartNumbersList, productArr: productArr });
  for (let i = 0; i < uniquePartNumbersList.length; i++) {
    let Lowest = 0;
    let Lowestflag = false;
    lowestIndex = 0;
    const filterProducts = productArr;
    // const filterProducts = productArr.filter(
    //(item) => item.api_partner != "tme" && item.api_partner != "rutronik"
    //);
    for (let j = 0; j < filterProducts.length; j++) {
      if (
        uniquePartNumbersList[i].mpn.toLowerCase() ==
          filterProducts[j].part_number.toLowerCase() &&
        uniquePartNumbersList[i].qty == filterProducts[j].qty
      ) {
        Lowestflag = true;
        const price = parseFloat(
          filterProducts[j].selectedPrice.price.replace(",", "")
        );
        if (Lowest == 0) {
          Lowest = price;
        }
        if (price <= Lowest) {
          lowestIndex = j;
          Lowest = price;
          onTotalPrice = parseInt(filterProducts[j].qty) * price;
        }
      }
    }
    if (Lowestflag) {
      sortProduct = {
        ...filterProducts[lowestIndex],
        totalPrice: onTotalPrice,
      };
      sortProArr = [...sortProArr, sortProduct];
    }
  }
  return sortProArr;
};

export const distributorSummary = (sortProArr, distributorMinimumPrice) => {
  const DistributorListArr = sortProArr.map(function (value) {
    return value.api_partner;
  });
  const uniqueDistributorListArr = [...new Set(DistributorListArr)];
  let distributorSummaryListArr = [];
  for (let i = 0; i < uniqueDistributorListArr.length; i++) {
    let distributorSummary = [];
    distributorSummary["minBomTotal"] = "";
    distributorSummary["distributor"] = uniqueDistributorListArr[i];
    distributorSummary["totalPrice"] = 0;
    distributorSummary["distributorItemCount"] = 0;
    for (let j = 0; j < sortProArr.length; j++) {
      if (uniqueDistributorListArr[i] == sortProArr[j].api_partner) {
        distributorSummary["totalPrice"] += sortProArr[j].totalPrice;
        distributorSummary["distributorItemCount"]++;
      }
    }
    let distributorMinBomTot = distributorMinimumPrice.filter(
      (distributor) =>
        distributor.name.toLowerCase() ==
        distributorSummary["distributor"].toLowerCase()
    );
    if (distributorMinBomTot.length > 0) {
      // console.log({ distributor: distributorSummary["distributor"], distributorMinBomTot: distributorMinBomTot });

      let minBomTotal = distributorMinBomTot.map((item) => item.minBomTotal);
      distributorSummary["minBomTotal"] = minBomTotal[0];
    }
    distributorSummaryListArr = [
      ...distributorSummaryListArr,
      distributorSummary,
    ];
  }
  return distributorSummaryListArr;
};
